import React, { useState } from 'react';
import { XIcon, CheckCircleIcon, MailIcon } from 'lucide-react';
interface PasswordResetModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const PasswordResetModal = ({
  isOpen,
  onClose
}: PasswordResetModalProps) => {
  const [email, setEmail] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call with timeout
    setTimeout(() => {
      setIsSubmitted(true);
      setIsLoading(false);
    }, 1500);
  };
  const handleClose = () => {
    onClose();
    // Reset state after animation completes
    setTimeout(() => {
      setIsSubmitted(false);
      setEmail('');
    }, 300);
  };
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-8447">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-navy-900/80 backdrop-blur-sm" onClick={handleClose} data-id="element-8448"></div>
      {/* Modal */}
      <div className="bg-white rounded-2xl w-full max-w-md p-6 shadow-xl relative z-10 animate-fadeIn" data-id="element-8449">
        <div className="flex justify-between items-center mb-6" data-id="element-8450">
          <h3 className="text-2xl font-serif font-bold text-navy-900" data-id="element-8451">
            {isSubmitted ? 'Check Your Email' : 'Reset Password'}
          </h3>
          <button onClick={handleClose} className="text-gray-500 hover:text-gray-700 transition-colors" aria-label="Close" data-id="element-8452">
            <XIcon className="h-5 w-5" data-id="element-8453" />
          </button>
        </div>
        {!isSubmitted ? <>
            <p className="text-gray-600 mb-6" data-id="element-8454">
              Enter your email address and we'll send you instructions to reset
              your password.
            </p>
            <form onSubmit={handleSubmit} data-id="element-8455">
              <div className="space-y-6" data-id="element-8456">
                <div data-id="element-8457">
                  <label htmlFor="reset-email" className="block text-sm font-medium text-gray-700 mb-1" data-id="element-8458">
                    Email Address
                  </label>
                  <input type="email" id="reset-email" value={email} onChange={e => setEmail(e.target.value)} className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-deep-pink focus:border-deep-pink text-gray-900" placeholder="you@example.com" required data-id="element-8459" />
                </div>
                <button type="submit" disabled={isLoading} className="w-full bg-deep-pink hover:bg-burgundy text-white font-medium py-3 px-4 rounded-lg transition-colors flex justify-center items-center" data-id="element-8460">
                  {isLoading ? <span className="inline-block h-5 w-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2" data-id="element-8461"></span> : null}
                  {isLoading ? 'Sending...' : 'Send Reset Instructions'}
                </button>
              </div>
            </form>
          </> : <div className="text-center" data-id="element-8462">
            <div className="flex justify-center mb-4" data-id="element-8463">
              <div className="bg-green-100 p-3 rounded-full" data-id="element-8464">
                <CheckCircleIcon className="h-10 w-10 text-green-500" data-id="element-8465" />
              </div>
            </div>
            <p className="text-gray-600 mb-4" data-id="element-8466">
              Reset instructions have been sent to:
            </p>
            <div className="bg-gray-100 rounded-lg p-3 mb-6 flex items-center justify-center gap-2" data-id="element-8467">
              <MailIcon className="h-5 w-5 text-gray-500" data-id="element-8468" />
              <span className="font-medium text-gray-800" data-id="element-8469">{email}</span>
            </div>
            <p className="text-sm text-gray-500 mb-6" data-id="element-8470">
              Please check your email and follow the instructions to reset your
              password. If you don't see the email, check your spam folder.
            </p>
            <button onClick={handleClose} className="w-full bg-deep-pink hover:bg-burgundy text-white font-medium py-3 px-4 rounded-lg transition-colors" data-id="element-8471">
              Close
            </button>
          </div>}
      </div>
    </div>;
};